import { useToggleByHash } from '../../../hooks/useToggleByHash';
import { urlHashes } from '../../../utils/helpers/constants';

export const useFullScreenGallery = () => {
  const { open: openModal } = useToggleByHash(urlHashes.fullScreenGallery);

  return openModal;
};
